export function format () {
  var args = arguments
  return args[0].replace(/\{(\d+)\}/g, function (match, number) {
    const index = Number(number) + 1
    return (args[index] !== undefined ? args[index] : match)
  })
}